$(document).ready(function () {
  $(".product_tab-list").each(function () {
    var heights2 = $("p.product__grid__title", this)
      .map(function () {
        return $(this).height();
      })
      .get();

    maxHeight2 = Math.max.apply(null, heights2);

    $("p.product__grid__title", this).css("height", maxHeight2 + "px");
  });

  if ($(window).width() < 1024) {
    var heights1 = $(".left_content")
      .map(function () {
        return $(this).height();
      })
      .get();

    maxHeight1 = Math.max.apply(null, heights1);
    $(".left_content").css("height", maxHeight1 + "px");
    var heights = $(".colletion-banner-content.banner_slider .slick-slide")
      .map(function () {
        return $(this).height();
      })
      .get();
    maxHeight = Math.max.apply(null, heights);
    $(".colletion-banner-content.banner_slider .slick-slide").css(
      "height",
      maxHeight + "px"
    );
  }

  $(".banner_btn").click(function (e) {
    e.preventDefault();
    var buttonAttr = $(this).attr("data-index");
    var title = $(this).attr("collection-title");
    $("#data-index" + buttonAttr).trigger("click");
    $("html, body").animate(
      {
        scrollTop: $(".collection_product-list").offset().top,
      },
      "300"
    );

    $("html, body").animate(
      { scrollTop: $(".collection_product-list").offset().top },
      500,
      "swing",
      function () {
        // window.location.hash = target;
      }
    );

    $(".colection_title.coll_list a").removeClass("active");
    // $('.menu_top_box').text(title);
    $(".mobile_list").removeClass("active");
    $('.mobile_list[product-title="' + title + '"]').addClass("active");
    $('.mobile_list[product-title="' + title + '"]').trigger("click");
    $('.coll_list a[product-title="' + title + '"]').addClass("active");
  });

  $(".prodcut_list").click(function () {
    // alert(1);
    var buttonAttr = $(this).attr("data-index");
    $("#data-index" + buttonAttr).trigger("click");
  });

  // Cookie functions
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  }

  // Remove active class from all items
  $("li.colection_title.prodcut_list.mobile_list").removeClass("active");
  $("li.colection_title.prodcut_list.mobile_list.coll_list a").removeClass(
    "active"
  );
  $("a.collection_all").removeClass("active");

  // Retrieve and set the active state on page load based on cookie
  var selectedProduct = getCookie("selectedProduct");

  if (selectedProduct) {
    // Find the item with the matching product-title attribute
    var productElement = $(
      'li.colection_title.prodcut_list.mobile_list[product-title="' +
        selectedProduct +
        '"]'
    );
    if (productElement.length) {
      productElement.addClass("active");
      $(".menu_top_box").text(selectedProduct);
    } else {
      // If the selectedProduct is not found, clear the cookie
      eraseCookie("selectedProduct");
    }

    // Find the link with the matching text (if applicable)
    $("li.colection_title.prodcut_list.mobile_list.coll_list a").each(
      function () {
        if ($(this).text() === selectedProduct) {
          $(this).addClass("active");
          $("li.colection_title.prodcut_list.mobile_list").removeClass(
            "active"
          );
        }
      }
    );
  }

  // Handle click event for collection all
  $("li.colection_title.coll_list a.collection_all").click(function () {
    $(".menu_top_box").text("Model");
    $(".other_tab").hide();
    setCookie("selectedProduct", "All", 7); // Set cookie for 'All'
    $("li.colection_title.prodcut_list.mobile_list").removeClass("active");
    $(this).addClass("active");
  });

  // Handle click event for product end tab
  $("li.colection_title.coll_list.product_end_tab a").click(function () {
    $(".top_tab").hide();
  });

  // Handle click event for mobile list
  $("li.colection_title.prodcut_list.mobile_list").click(function () {
    var dataAtr = $(this).attr("product-title");
    //console.log(dataAtr);
    $("li.colection_title.prodcut_list.mobile_list").removeClass("active");
    $(this).addClass("active");
    $("li.colection_title.prodcut_list.mobile_list.coll_list a").removeClass(
      "active"
    );
    $(".top_tab.1").hide();
    $(".menu_top_box").text(dataAtr);
    $(".product_drop_down").hide();
    $(".last_tab").hide();
    setCookie("selectedProduct", dataAtr, 7); // Set cookie with 7 days expiration
  });

  // Handle click event for collection list links
  $("li.colection_title.prodcut_list.mobile_list.coll_list a").click(
    function () {
      var dataAtr = $(this).text();
      // console.log(dataAtr);
      $("li.colection_title.prodcut_list.mobile_list.coll_list a").removeClass(
        "active"
      );
      $(this).addClass("active");
      $("li.colection_title.prodcut_list.mobile_list").removeClass("active");
      $(".menu_top_box").text(dataAtr);
      $(".product_drop_down").hide();
      $(".last_tab").hide();
      setCookie("selectedProduct", dataAtr, 7); // Set cookie with 7 days expiration
    }
  );
  $(document).ready(function () {
    $(".colection_dropdown").on("click", function () {
      // Remove 'active' class from all '.collection_all' elements
      $(".colection_title .collection_all").removeClass("active");
    });
  });

  $(".select_menu_box").click(function () {
    $(".product_drop_down").slideToggle();
    $(".select_menu_box").toggleClass("dropdown");
  });
  $(".menu_top_box").click(function () {
    $(".product_drop_down").slideToggle();
    $(".select_menu_box").toggleClass("dropdown");
  });
  // $(".mobile_slider").slick({
  //   infinite: false,
  //   slidesToShow: 2.2,
  //   slidesToScroll: 1,
  //   autoplay: false,
  //   autoplaySpeed: 3000,
  //   arrows: false,
  //   dots: false,
  //   accessibility: true,
  //   //centerMode: true,
  //   responsive: [
  //     {
  //       breakpoint: 991,
  //       settings: {
  //         slidesToShow: 2.2,
  //       },
  //     },
  //     {
  //       breakpoint: 475,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //   ],
  // });

  // $('ul.tabs').each(function(){
  //   var active, content, links = $(this).find('.coll_list a');
  //   //active_hasClass = $(this).hasClass("desktop_view");
  //   // if(active_hasClass){
  //   //   active = links.first().attr('class');
  //   //   alert(active);
  //   // }
  //   // else{
  //     active = links.first().addClass('active');
  //   //}

  //   content = $(active.attr('href'));
  //   links.not(':first').each(function () {
  //     $($(this).attr('href')).hide();
  //   });
  //   $(this).find('.coll_list a').click(function(e){
  //     // $('.mobile_view').hide();
  //     setTimeout(function() {
  //        // $('.mobile_view').show();
  //      $('.mobile_slider').slick('setPosition');
  //        }, 100);
  //     active.removeClass('active');
  //     content.hide();
  //     active = $(this);
  //     content = $($(this).attr('href'));
  //     active.addClass('active');
  //     content.show();
  //     return false;
  //   });

  // });

  $(document).ready(function () {
    // Function to get a cookie value by name
    function getCookie(name) {
      var match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? match[2] : null;
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    $("ul.tabs").each(function () {
      var active,
        content,
        links = $(this).find(".coll_list a");

      // Retrieve the cookie
      var activeTab = getCookie("activeTab");

      // Remove active class from all tabs
      links.removeClass("active");

      if (activeTab) {
        // Find the tab based on the cookie value
        active = $(this).find(
          '.coll_list a[data-collection="' + activeTab + '"]'
        );
        if (active.length) {
          content = $(active.attr("href"));
        } else {
          // Fallback to the first tab if the cookie value is not found
          active = links.first();
          content = $(active.attr("href"));
        }
      } else {
        // Default to the first tab if no cookie is set
        active = links.first();
        content = $(active.attr("href"));
      }

      // Set the initial state
      active.addClass("active");
      content.show();

      // Hide content for tabs that are not active
      links.not(active).each(function () {
        $($(this).attr("href")).hide();
      });

      $(this)
        .find(".coll_list a")
        .click(function (e) {
          e.preventDefault();

          // Hide mobile view and adjust slider position if needed
          setTimeout(function () {
            $(".mobile_slider").slick("setPosition");
          }, 100);

          // Remove active class from previous tab
          active.removeClass("active");
          content.hide();

          // Set new active tab
          active = $(this);
          content = $($(this).attr("href"));
          active.addClass("active");
          content.show();

          // Set cookie with the data-collection value of the clicked tab
          setCookie("activeTab", active.data("collection"), 7);

          document.getElementById("ProductGridContainer").style.display =
            "none";
          document.getElementById("ProductGridContainerNew").style.display =
            "block";
          return false;
        });
    });
  });

  $(".feature_hover_content").hover(function () {
    $(".featured_content_outerdesktop").toggleClass("acive");
  });

  $(".featured_text.mobile_text").click(function () {
    var dataVal = $(this).attr("data-indexing");

    $("#tooltip-" + dataVal).toggleClass("acive");
  });

  $(".mobbile_text1").click(function () {
    var dataVal = $(this).attr("data-indexing");
    $("#tooltip1-" + dataVal).toggleClass("acive");
  });
});
$(document).ready(function () {
  setTimeout(function () {
    if ($("body").hasClass("collection")) {
      var main_collection = $(".collection_product-list").attr(
        "data-collection"
      );
      // console.log(main_collection);
      $(".colection_title.coll_list a").each(function () {
        var text = $(this).attr("data-collection");
        // console.log(text);
        // console.log("sili---" + text);
        if (main_collection.indexOf(text) > -1) {
          //  console.log("text---" + text);
          $(this).trigger("click");
        }
      });
    }
  }, 2000);
});
// for Product description//
$(document).ready(function () {
  $("#toggle-btn").click(function () {
    var text = $("#more-text");
    var btn = $(this);
    text.toggle();
    if (text.is(":visible")) {
      btn.text("See Less");
    } else {
      btn.text("See More");
    }
  });
});
//accessabilty widget app
$(document).ready(function () {
  const checkInterval = setInterval(function () {
    function applyStyles() {
      const triggerHost = $("trigger-host");

      if (triggerHost.length) {
        const shadowRoot = triggerHost[0].shadowRoot;
        if (shadowRoot) {
          $(shadowRoot).find(".trigger-container").css({
            top: "unset",
            position: "fixed",
          });

          if (window.innerWidth > 768) {
            $(shadowRoot).find(".trigger-container").css({
              bottom: "50px",
              left: "90px",
            });
          }
          if (window.innerWidth <= 768) {
            $(shadowRoot).find(".trigger-container").css({
              bottom: "24px",
              left: "100px",
            });
          }
          if (window.innerWidth <= 768) {
            $(shadowRoot).find(".trigger-container").css({
              bottom: "50px",
              left: "10px",
            });
          }
          if($("body").hasClass("show-navigation-jtpl")){
           $(shadowRoot).find(".trigger-container").css({
              bottom: "160px",
            });
          }
          if (window.innerWidth == 768) {
            $(shadowRoot).find(".trigger-container").css({
              bottom: "18px",
              left: "88px",
            });
          }
          $(shadowRoot)
            .find(
              "#HikeOrdersA11YEnabler .trigger-container .triggerIcon.icon-a11y-1"
            )
            .css({ top: "-6.2px", left: "-4.2px", fontSize: "37.5px" });
          $(shadowRoot)
            .find("#HikeOrdersA11YEnabler .trigger-container [role='button']")
            .css({ width: "48px", height: "48px" });
        }
      }
    }
    $(window).on("resize load scroll", function () {
      applyStyles();
    });
    clearInterval(checkInterval);
  }, 100);
});
